import React from 'react';
import cn from 'classnames';

import LandingPageLink from 'components/landing/LandingPageLink';
import { makeComponentHeading } from 'helpers/LandingPageUtils';
import css from 'styles/components/landing/contentBox.scss';

const ContentBox = ({ slotDetails, componentName, onLandingComponentClick, slotIndex }) => {
  const { type, heading, subheading, link, copy, subtext, extrainfo, cta } = slotDetails;
  const linkProps = {
    'onClick': onLandingComponentClick,
    'data-eventlabel': `${componentName}-${cta}`,
    'data-eventvalue': `${link}`,
    'data-slotindex': slotIndex
  };
  const altType = type === 'hero' ? css.altHero : css.altProd;

  const makeHeading = heading => makeComponentHeading({ heading, className: altType });

  const makeCtaBtn = () => cta && link && (
    <div className={cn(css.cta, altType)}>
      <LandingPageLink url={link} {...linkProps}>
        {cta}
      </LandingPageLink>
    </div>
  );

  return (
    <>
      {makeHeading(heading)}
      {subheading && <p className={css.subheading}>{subheading}</p>}
      {subtext && <p className={css.subtext}>{subtext}</p>}
      {extrainfo && <p className={css.extrainfo}>{extrainfo}</p>}
      {copy && <p className={css.copy}>{copy}</p>}
      {makeCtaBtn()}
    </>
  );
};

export default ContentBox;
